export enum ChartSetupViewOptionsEnum {
    showDescription,
    hideDescription
};
